var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.273 512h-302.546c-19.2 0-34.909-15.709-34.909-34.909v-442.182c0-19.2 15.709-34.909 34.909-34.909h209.455l128 128v349.091c0 19.2-15.709 34.909-34.909 34.909z",
    fill: "#00ad3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.182 0 128 128h-128z",
    fill: "#00831e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.636 200.728v162.909h232.727v-162.909zm101.819 133.817h-72.727v-37.817h72.727zm0-66.908h-72.727v-37.818h72.727zm101.818 66.908h-72.727v-37.817h72.727zm0-66.908h-72.727v-37.818h72.727z",
    fill: "#fbffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSheets);
export default __webpack_public_path__ + "static/media/google-sheets.7aa80cc22962bc31f83101c30802560a.svg";
export { ForwardRef as ReactComponent };